import React from 'react';
import { Spinner } from '../../../components/UI';
import {
    Button,
    Paper,
    Box,
    Typography,
    makeStyles,
    IconButton,
    Tooltip,
    TablePagination,
    Grid,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Divider,
    ListItemIcon,
} from '@material-ui/core';
import {
    CM_FILTER_CARDS,
    generateEVWalletPassbookData,
    PASSBOOK_TABLE_COLUMNS,
    TL_FILTER_CARDS,
    TL_TABLE_COLUMNS,
} from '../helper.cm';
import Searchbar from '../../../components/Searchbar';
import FilterModal, {
    FilteredState,
} from '../../../components/Modals/FilterModal';
import { CM_TABLE_COLUMNS } from '../helper.cm';
import { CMTableCell, CMTableHeadCell } from '../utility.component.cm';
import useRider from './useRider';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import clsx from 'clsx';
import { TrackingEnabledIcon } from '../../../assets/svg';
import ViewPassbookModal from '../../../components/Modals/ViewPassbookModal';

interface SingleTeamLeadPageProps {
    [key: string]: any;
}
const SingleTeamLeadRiderPage: React.FC = ({
    ...props
}: SingleTeamLeadPageProps) => {
    //store values
    const {
        isLoading,
        styles,
        activeFilterCard,
        prepareFilterCard,
        prepareFilterOptions,
        containerRef,
        searchTextValue,
        onFilterApplied,
        filterValues,
        pagination,
        handleChangePage,
        handleChangeRowsPerPage,
        onBackendSearch,
        onSearchTextChange,
        onRemoveAll,
        getColumnComponentValue,
        cm,
        handleActiveFilterCard,
        teamLeadRiderDetails,
        chipClass,
        commonStyles,
        loginClass,
        permissions,
        handleRowClick,
        riderPassbook,
        passbookModalOpen,
        selectedPassbook,
        handlePassbookModalOpen,
        handlePassbookModalClose,
    } = useRider(props);
    console.log('teamLeadRiderDetails', teamLeadRiderDetails);
    const lineItems = generateEVWalletPassbookData(
        riderPassbook?.historyLineItems,
    );
    console.log('lineItems', lineItems);
    return (
        <Spinner loading={isLoading}>
            <Paper
                style={{ padding: '1rem' }}
                className={styles.filterContainer}
                elevation={0}
            >
                <Grid
                    container
                    spacing={1}
                    direction="row"
                    alignItems={'center'}
                >
                    <Grid item xs={9}>
                        <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-start'}
                        >
                            <ListItemIcon
                                onClick={(e) =>
                                    props?.history.push(
                                        `/cluster-management/details/${props?.match?.params?.id}`,
                                        {
                                            payload:
                                                props?.location?.state
                                                    ?.backPayload,
                                        },
                                    )
                                }
                                className={styles.backIcon}
                            >
                                <ArrowBackIcon
                                    style={{
                                        fontSize: '1.5rem',
                                    }}
                                />
                            </ListItemIcon>
                            <Box flex={1}>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    justifyContent={'flex-start'}
                                >
                                    <Typography
                                        className={commonStyles.boldText}
                                    >
                                        {teamLeadRiderDetails?.deName}
                                    </Typography>
                                    {!!teamLeadRiderDetails?.status && (
                                        <Box
                                            className={clsx([
                                                commonStyles.chip,
                                                chipClass,
                                            ])}
                                        >
                                            <Typography
                                                component={'span'}
                                                className={
                                                    commonStyles.chipText
                                                }
                                            >
                                                {teamLeadRiderDetails?.status ??
                                                    '-'}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                                <Box
                                    display={'flex'}
                                    alignItems={'center'}
                                    flexDirection={'row'}
                                    flex={1}
                                >
                                    <Typography
                                        className={clsx(styles.tableValue)}
                                    >
                                        {teamLeadRiderDetails?.dePhoneNumber ??
                                            ''}
                                        {teamLeadRiderDetails?.hubName && (
                                            <Typography
                                                className={styles.tableValue}
                                                component={'span'}
                                            >
                                                {teamLeadRiderDetails.dePhoneNumber
                                                    ? ` | `
                                                    : ''}
                                                {` ${teamLeadRiderDetails?.hubName}`}
                                            </Typography>
                                        )}
                                        {teamLeadRiderDetails?.hubName &&
                                            teamLeadRiderDetails?.cityName && (
                                                <Typography
                                                    className={
                                                        styles.tableValue
                                                    }
                                                    component={'span'}
                                                >
                                                    {`, ${teamLeadRiderDetails?.cityName}`}
                                                </Typography>
                                            )}
                                        {teamLeadRiderDetails?.evNumber && (
                                            <Typography
                                                className={styles.tableValue}
                                                component={'span'}
                                            >
                                                {` | ${teamLeadRiderDetails?.evNumber}`}
                                            </Typography>
                                        )}
                                        {teamLeadRiderDetails?.evVehicleNumber && (
                                            <Typography
                                                className={styles.tableValue}
                                                component={'span'}
                                            >
                                                {` | ${teamLeadRiderDetails?.evVehicleNumber}`}
                                            </Typography>
                                        )}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        {/* <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-end'}
                        >
                            <Button
                                variant="contained"
                                style={{ fontSize: 14 }}
                                color="primary"
                                onClick={(e) => {}}
                                //disabled={!permissions.update}
                                disableElevation
                            >
                                {'Edit Info'}
                            </Button>
                        </Box> */}
                        {/* <Box
                            display={'flex'}
                            flexDirection={'row'}
                            alignItems={'center'}
                            justifyContent={'flex-end'}
                            mt={'8px'}
                        >
                            <div
                                style={{
                                    marginRight: '.5rem',
                                    marginLeft: '.5rem',
                                }}
                            >
                                <TrackingEnabledIcon />
                            </div>
                            <Typography
                                style={{
                                    fontFamily: 'Nunito',
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                    color: '#14112d',
                                }}
                                className="tracking-text"
                                variant="body1"
                                gutterBottom
                            >
                                {`Tracking Enabled`}
                            </Typography>
                        </Box> */}
                    </Grid>
                </Grid>
            </Paper>
            <Paper style={{ padding: '1rem', paddingBottom: 0 }} elevation={0}>
                <Paper
                    ref={containerRef}
                    className={styles.container}
                    elevation={0}
                >
                    {lineItems?.length ? (
                        <>
                            <TableContainer
                                component={Box}
                                className={styles.tableRiderContainer}
                            >
                                <Table
                                    stickyHeader
                                    aria-label="Team Leads Rider Passbook table"
                                >
                                    <TableHead>
                                        <TableRow>
                                            {PASSBOOK_TABLE_COLUMNS?.map(
                                                (column: any, index: any) => {
                                                    return (
                                                        <CMTableHeadCell
                                                            key={`column${index}`}
                                                        >
                                                            {column?.name}
                                                        </CMTableHeadCell>
                                                    );
                                                },
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {lineItems?.map(
                                            (row: any, rowIndex?: number) => (
                                                <>
                                                    <TableRow key={rowIndex}>
                                                        {PASSBOOK_TABLE_COLUMNS?.map(
                                                            (
                                                                column: any,
                                                                index: any,
                                                            ) => {
                                                                return (
                                                                    <CMTableCell
                                                                        key={`row${index}`}
                                                                    >
                                                                        {getColumnComponentValue(
                                                                            row,
                                                                            column,
                                                                        )}
                                                                    </CMTableCell>
                                                                );
                                                            },
                                                        )}
                                                    </TableRow>
                                                    <Divider
                                                        style={{
                                                            margin: '4px 0',
                                                            backgroundColor:
                                                                '#fff',
                                                        }}
                                                    />
                                                </>
                                            ),
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </>
                    ) : (
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            alignItems={'center'}
                            justifyContent={'center'}
                        >
                            <Typography
                                component={'p'}
                                style={{
                                    color: '#ED0000',
                                    fontWeight: 700,
                                }}
                            >
                                No data available
                            </Typography>
                        </Box>
                    )}
                    {!!lineItems?.length && (
                        <Box className={styles.paginationContainer}>
                            <TablePagination
                                rowsPerPageOptions={
                                    cm?.fleets?.totalFilteredCount > 25
                                        ? [25, 50, 75, 100]
                                        : []
                                }
                                component="div"
                                count={
                                    cm?.fleets?.totalFilteredCount ??
                                    cm?.fleets?.teamLeadFleetLineItemList
                                        ?.length
                                }
                                rowsPerPage={pagination?.pageSize}
                                page={pagination?.pageNo}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        </Box>
                    )}
                </Paper>
            </Paper>
            {passbookModalOpen && selectedPassbook?.subLineItems?.length && (
                <ViewPassbookModal
                    open={passbookModalOpen}
                    tlRiderInfo={{
                        ...teamLeadRiderDetails,
                        id:
                            props?.match?.params?.id ??
                            teamLeadRiderDetails?.userId,
                    }}
                    data={selectedPassbook}
                    onClose={() => {
                        handlePassbookModalClose();
                    }}
                />
            )}
        </Spinner>
    );
};
export default SingleTeamLeadRiderPage;
